import React from "react";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import MtechInternational_admissionEle from "./MtechInternational_admissionEle";

function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Admission" />
            <MtechInternational_admissionEle />
        </>
    );
}

export default Main;
